export default __webpack_public_path__ + "static/media/icon-android.c3d2fb98.svg";